export const DEV_URL = "http://localhost:5000";
// export const PROD_URL = "http://localhost:5000";
// export const PROD_URL = 'https://c3ecf5cdd5dd.ngrok.io'
export const PROD_URL = "https://mvp5backend-jdmpreemfq-uc.a.run.app";
//
